import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideEdgeFlagModal, sendEdgeFlag } from 'store/core/actions';
import { selectEdgeFlagModalState, selectEdgeFlagError } from 'store/core/selectors';
import { FaCheckCircle, FaFlag } from 'react-icons/fa';
import { AiOutlineClose } from 'react-icons/ai';
import styles from './flagModal.module.css';

const FLAG_CATEGORIES = [
  { value: 'incorrect', label: 'Incorrect Data' },
  { value: 'incomplete', label: 'Incomplete Data' },
  { value: 'needs_verification', label: 'Needs Verification' },
  { value: 'other', label: 'Other' },
];

export const FlagEdgeModal = () => {
  const dispatch = useDispatch();
  const edgeFlagModalState = useSelector(selectEdgeFlagModalState);
  const edgeFlagError = useSelector(selectEdgeFlagError);
  
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const { isOpen, edgeId, connectionType, outV, inV, connection, success } = edgeFlagModalState;

  useEffect(() => {
    if (edgeFlagError) {
      setIsLoading(false);
    }
    if (success === 'success') {
      setTimeout(() => dispatch(hideEdgeFlagModal()), 1500);
    }
  }, [edgeFlagError, success, dispatch]);

  const handleClose = () => {
    setDescription('');
    setCategory('');
    dispatch(hideEdgeFlagModal());
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!category) {
      alert('Please select a category');
      return;
    }
    setIsLoading(true);
    const edgeContext = {
      connectionType,
      outV,
      inV,
      connection,
    };
    dispatch(sendEdgeFlag(edgeId, description, category, edgeContext));
  };

  if (!isOpen) return null;

  // Success state
  if (success === 'success') {
    return (
      <div className={styles.overlay}>
        <div className={styles.modal}>
          <div className={styles.successContent}>
            <FaCheckCircle className={styles.successIcon} />
            <p>Flag submitted successfully!</p>
          </div>
        </div>
      </div>
    );
  }

  // Build edge display string
  const edgeDisplay = connection || `${connectionType} (${outV} → ${inV})`;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <div className={styles.headerTitle}>
            <FaFlag className={styles.flagIcon} />
            <span>Flag Data Issue</span>
          </div>
          <AiOutlineClose className={styles.closeIcon} onClick={handleClose} />
        </div>
        
        <div className={styles.content}>
          <div className={styles.nodeInfo}>
            <span className={styles.nodeLabel}>Edge:</span>
            <span className={styles.nodeName}>{edgeDisplay}</span>
          </div>

          <form onSubmit={handleSubmit}>
            <div className={styles.formGroup}>
              <label className={styles.label}>Category *</label>
              <select
                className={styles.select}
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                required
              >
                <option value="">Select a category...</option>
                {FLAG_CATEGORIES.map((cat) => (
                  <option key={cat.value} value={cat.value}>
                    {cat.label}
                  </option>
                ))}
              </select>
            </div>

            <div className={styles.formGroup}>
              <label className={styles.label}>Description</label>
              <textarea
                className={styles.textarea}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Describe the issue with this data..."
                rows={4}
              />
            </div>

            {edgeFlagError && (
              <div className={styles.error}>{edgeFlagError}</div>
            )}

            <div className={styles.actions}>
              <button
                type="button"
                className={styles.cancelButton}
                onClick={handleClose}
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className={styles.submitButton}
                disabled={isLoading}
              >
                {isLoading ? 'Submitting...' : 'Submit Flag'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FlagEdgeModal;
